'use client';

import { faPlayCircle } from '@fortawesome/free-solid-svg-icons';

import CtaButton from '@/components/CtaButton';
import { clickVisitLandingPageLink } from '@/utils/analytics/log-event';

type Props = {
  authorName: string;
  categorySlug: string;
};

const Component: React.FC<Props> = ({ authorName, categorySlug }) => {
  return (
    <div>
      <p className="mb-2 text-center text-sm font-bold text-gray-500">
        プレミアムサービスで{authorName}の卓球指導動画が見放題
      </p>

      <CtaButton
        icon={faPlayCircle}
        caption="卓球レッスン動画を見る"
        onClick={() =>
          clickVisitLandingPageLink('blog_under_content', categorySlug)
        }
      />
    </div>
  );
};

export default Component;
